import {
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
  FormErrorMessage,
  Stack,
  Text,
} from '@chakra-ui/react';
import React from 'react';

type Option = {
  value: string;
  label: string;
};

export interface RadioButtonFieldProps {
  label?: React.ReactNode;
  name: string;
  options: Option[];
  isDisabled?: boolean;
  error?: string;
  value?: string;
  fontWeight?: string;
  fontSize?: string;
  mb?: string;
  [x: string]: any;
}

export const RadioButtonField: React.FC<RadioButtonFieldProps> = ({
  label,
  name,
  options,
  error,
  value,
  onChange,
  fontWeight,
  fontSize,
  mb,
  isDisabled,
  ...rest
}) => {
  return (
    <FormControl isInvalid={!!error} mb={mb || 4}>
      {label && <FormLabel htmlFor={name}>{label}</FormLabel>}
      <RadioGroup name={name} value={value} onChange={onChange} isDisabled={isDisabled}>
        <Stack direction="column">
          {options.map((option) => (
            <Radio key={option.value} value={option.value} colorScheme="primary" {...rest}>
              <Text fontWeight={fontWeight} fontSize={fontSize}>
                {option.label}
              </Text>
            </Radio>
          ))}
        </Stack>
      </RadioGroup>
      {error && <FormErrorMessage>{error}</FormErrorMessage>}
    </FormControl>
  );
};
